import { Routes } from '@angular/router';

import { FontDemoComponent } from './font-demo.component';

export const fontRoutes: Routes = [
  { path: 'fonts', component: FontDemoComponent },
];



// WEBPACK FOOTER //
// ./src/app/font/font.routes.ts